import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';
import { useAuth } from '@/contexts/AuthContext';
import { resolveQuestionnaireLink } from '@/lib/questionnaireLink/questionnaireLink';
import type { UserRole } from '@/types';

/**
 * `/q` (#125): the public questionnaire link. Signed out → sign in and come
 * back here (like `/clinic/:coachId`); signed in → the beneficiary dashboard
 * with the «مقياس نمط» window open.
 */
export function QuestionnaireLinkPage() {
  const { currentUser, userData, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const activeRoles = (userData?.roles ?? [])
      .filter((r) => r.isActive)
      .map((r) => r.role as UserRole);
    const step = resolveQuestionnaireLink({
      loading,
      signedIn: Boolean(currentUser || userData),
      profileLoaded: Boolean(userData),
      activeRoles,
    });
    if (step.kind === 'login') {
      sessionStorage.setItem('redirectAfterLogin', step.redirectAfterLogin);
      navigate('/login', { replace: true });
    } else if (step.kind === 'navigate') {
      navigate(step.to, { replace: true });
    }
  }, [loading, currentUser, userData, navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center">
      <Loader2 className="h-8 w-8 animate-spin text-primary" />
    </div>
  );
}
